import { Navigate } from "react-router";
import { accessToken } from "../helpers/sessionKey";

interface IPrivateRoute {
  children: JSX.Element;
}

const PrivateRoute: React.FC<IPrivateRoute> = ({ children }) => {
  const token = accessToken();
  if (!token) {
    return <Navigate to="/auth-login" />;
  }
  return children;
};

export default PrivateRoute;